export class OTA_ConfID {
    public type: string;
    public confID: string;
}